<div class="container my-4">
    <div class="row">
        <div class="col-12">
            <span class="title_header_bar">Link Address Change
            </span>
        </div>
    </div>
    <div class="card card_content">
        <div
            class="col-md-12 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <!-- <button
                    type="button"
                    class="btn btn-secondary mr-2"
                    (click)="clearFilter()">
                    <i class="fa fa-refresh"></i> Refresh
                </button> -->
                <app-button (refreshClicked)="clearFilter()"></app-button>

            </div>
        </div>
        <form [formGroup]="form">
        <div class="row d-flex justify-content-center">

            <div class="col-sm-12 col-md-5 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>Old Application No</mat-label>
                    <input matInput  maxlength="25" formControlName="existingApplicationNo"
                        placeholder="Enter Old Application" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-5 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>New Application No</mat-label>
                    <input matInput  maxlength="25" formControlName="newApplicationNo"
                        placeholder="Enter New Application" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
        </div>
            <div class="col-xl-12 text-center mt-5">
                <button class="btn btn-primary mr-3" (click)="Submit()">
                  <i class="fa fa-link mr-2"></i>  Link Order
                </button>

        </div>
    </form>

    </div>
</div>
